export default "__VITE_PUBLIC_ASSET__ec7eee2d__"